import { Popover } from "antd"
import OutsideAlerter from "components/view-utils/outside-alerter"
import { useState } from "react"
import { SidebarButton } from "../sidebar-button"
import { useFormikContext } from "formik"
import { TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import ProjectSelect from "components/timenotes/projects/project-select"

interface TaskProjectSelectPopoverProps extends React.PropsWithChildren { }

export const TaskProjectSelectPopover = (props: TaskProjectSelectPopoverProps) => {

  const formik = useFormikContext<TApiTaskDetails>()
  const task = formik.values

  const [visible, setVisible] = useState(false)

  return (
    <>
      <OutsideAlerter
        onClick={() => setVisible(false)}
      >
        <Popover
          getPopupContainer={(triggerNode: any) => triggerNode}
          content={(

            <ProjectSelect
              style={{
                width: '300px'
              }}
              getPopupContainer={(triggerNode) => triggerNode}
              autoFocus
              open={true}
              onKeyDown={(e: any) => {
                if (e.key == 'Escape') {
                  setVisible(false)
                }
              }}

              value={task.project}
              onChange={(v) => {
                console.error("New project", v)

                // Just exclude the label from records-select ugly API
                // @ts-ignore
                const { label, ...newProject } = v
                formik.setFieldValue('project', newProject)
                formik.submitForm()
                setVisible(false)
              }}
            />
          )}
          destroyTooltipOnHide={true}
          placement="bottom"
          trigger={[]}
          visible={visible}
        >
          <div onClick={() => setVisible((v) => (!v))}>
            {props.children || <DefaultTarget />}
          </div>
        </Popover>
      </OutsideAlerter>

      <div
        style={{
          cursor: 'pointer',
          marginLeft: '8px',
        }}
        onClick={() => setVisible(true)}
      >
        { task.project.name }
      </div>

    </>
  )
}

const DefaultTarget = () => {
  return (
    <SidebarButton>
      Project
    </SidebarButton>
  )
}
